// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291210/js/" + chunkId + "." + {"44":"897c10ad","225":"b64ca827","481":"e4cd98f8","486":"e5b1fb7c","770":"d355b545"}[chunkId] + ".0.0397498499948058.chunk.js";
};